import { Trans } from "@lingui/macro";

import { firstRoundLegalUrl } from "@/client/utils/firstRoundAppUrl";

const LINK_CLASS = "font-medium text-sky-600 underline";

/** Points readers of theResume's own terms and privacy policy at First Round's separate set. */
export const FirstRoundLegalNotice = () => (
  <p className="ml-10 mt-3 text-sm text-gray-600">
    <Trans>
      Using First Round, our AI practice interview service? It has its own{" "}
      <a
        href={firstRoundLegalUrl("/terms")}
        target="_blank"
        rel="noopener noreferrer"
        className={LINK_CLASS}
      >
        Terms of Service
      </a>{" "}
      and{" "}
      <a
        href={firstRoundLegalUrl("/privacy")}
        target="_blank"
        rel="noopener noreferrer"
        className={LINK_CLASS}
      >
        Privacy Policy
      </a>
      .
    </Trans>
  </p>
);
